import { lrpQuoteSchema } from '@harvestiq/usda-common';
import { z, zDecimalRequired } from '@harvestiq/zod';
import { getLrpQuoteAndPdfParamsSchema } from './get-lrp-quote-and-pdf-params-schema';
import { LrpCampaignPdfColumns } from '@harvestiq/constants';

export const createLrpQuotePDFSchema = getLrpQuoteAndPdfParamsSchema
  .omit({
    targetSalesEffectiveDate: true,
    targetWeight: true,
  })
  .extend({
    salesEffectiveDate: z.string(),
    quotes: z.record(z.string(), lrpQuoteSchema.array()),
    targetWeight: zDecimalRequired(),
    quoteColumns: z.array(z.nativeEnum(LrpCampaignPdfColumns)).optional(),
    logoUrl: z.string().url(),
    orgId: z.string(),
    campaignId: z.string().optional(),
  });
export type CreateLrpQuotePDFParams = z.infer<typeof createLrpQuotePDFSchema>;
